import { MetaPaginatorConstructor } from "../interfaces/meta.paginator";

export interface DdtsAPIDetailsListResponse {
    data: DdtDetailsListItemConstructor[];
    meta: MetaPaginatorConstructor;
}

export interface DdtDetailsListItemConstructor {
    line_obj_no: string;
    line_no: string;
    description: string;
    description2: string;
    shipment_date: string;
    quantity: number;
    unit_price: number;
    discount_percent: number;
    tax_percent: number;
}

export class DdtDetailsListItemModel {
    lineObjNo: string;
    lineNo: string;
    description: string;
    description2: string;
    shipmentDate: string | null;
    quantity: number;
    unitPrice: number;
    discountPercent: number;
    taxPercent: number;
    constructor(data: DdtDetailsListItemConstructor) {
        this.lineObjNo = data.line_obj_no || "";
        this.lineNo = data.line_no || "0";
        this.description = data.description || "";
        this.description2 = data.description2 || "";
        this.shipmentDate = this.parseShipmentDate(data.shipment_date);
        this.quantity = data.quantity || 0;
        this.unitPrice = data.unit_price || 0;
        this.discountPercent = data.discount_percent || 0;
        this.taxPercent = data.tax_percent || 0;
    }

    private parseShipmentDate(date: string): string | null {
        if (!date || date === "0001-01-01" || date.startsWith("0001-")) {
            return null;
        }
        return date;
    }
}
